<sh-page [theme]="themeService.theme" scrollable>
  <div class="container">
    <backend-header></backend-header>
    <backend-branding></backend-branding>
    <backend-build-parent></backend-build-parent>
  </div>
</sh-page>
